import { createStore } from 'vuex'

export default createStore({
  state: {
    layoutName: 'default',
    isLoading: true,
    Loans: {},
    loanData: null,
    advSParams: {},
    selectedCities: [],
    displayDate: {}
  },
  mutations: {
    setLayout(state, layout){
      state.layoutName = layout
    },
    setLoading(state, isLoading){
      state.isLoading = isLoading
    },
    setLoans(state, loan){
      state.Loans = loan
    },
    setnewLoanData(state, ld){
      state.loanData = ld
    },
    setAdvSParams(state, sParams){
      state.advSParams = sParams;
    },
    setSelectedCities(state, data) {
      state.selectedCities = data;
    }
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setLoading({commit}, isLoading){
      commit('setLoading', isLoading);
    },
    setLoans({commit}, loan){
      commit('setLoans', loan)
    },
    setnewLoanData({commit}, ld){
      commit('setnewLoanData', ld);
    },
    setAdvSParams({commit}, sParams){
      commit('setAdvSParams', sParams);
    },
    setSelectedCities({commit}, data) {
      commit('setSelectedCities', data);
    }
  },
  getters: {
    layout(state){
      return state.layoutName;
    },
    isLoading(state){
      return state.isLoading;
    },
    loanKeys(state){
      return state.Loans;
    },
    loanData(state){
      return state.loanData;
    },
    advSParams(state){
      return state.advSParams;
    },
    selectedCities(state) {
      return state.selectedCities;
    }
  },
})
